import React, { useRef } from "react";
import Slider from "react-slick";
import { useMediaQuery } from "react-responsive";
import { FaCircleArrowLeft, FaCircleArrowRight } from "react-icons/fa6"; // custom arrows
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FiArrowLeftCircle } from "react-icons/fi";
import { FiArrowRightCircle } from "react-icons/fi";


const SectionThree = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const sliderRef = useRef(null);

  const testimonials = [
    {
      title: "Conversion rate has increased to 45%",
      quote:
        '"KwikCheckout has been a game-changer. Our conversion rate has climbed to 45%, ROAS has improved, and prepaid orders are growing. The seamless checkout, especially the pre-filled address feature, has transformed the customer experience. Plus, the support team is always responsive and proactive."',
      image: "/assets/images/custom-checkout/woodland-founder.jpeg",
      founder_name: "Varun Chandra",
      company_name: "Lead D2C, Woodland Worldwide ",
    },
    {
      title: "40% reduction in RTOs",
      quote:
        '"We achieved a remarkable 40% reduction in our overall RTO along with a 20% uplift in prepaid share of wallet. Thanks to KwikCheckout!"',
      image: "/assets/images/custom-checkout/mac-founder.png",
      founder_name: "Vaishali Gupta",
      company_name: "Co-founder & Chief Growth Officer, mCaffeine",
    },
  ];

  const settings = {
    dots: false,
    arrows: false, // ✅ disable built-in arrows
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };

  return (
    <div
      className="secthree-cc--wrapper secthree-cc--wrapper-mob position-relative overflow-hidden section-three-slider"
      style={{ minHeight: isMobile ? "66vh" : "62vh" }}
    >
      <Slider ref={sliderRef} {...settings}>
        {testimonials.map((t, index) => (
          <div
            key={index}
            className="secthree-cc-ontainer"
            style={{ color: "black", zIndex: 1 }}
          >
            <div
              className={`secthree-cc--content ${
                isMobile ? "secfive-content-mob" : ""
              }`}
            >
              <div className="secthree-cc--left">
                <p
                  className={`secthree-cc--title ${
                    isMobile ? "secthree-cc--title-mob" : ""
                  }`}
                >
                  {t.title}
                </p>
                <p
                  className={`secthree-cc--quote ${
                    isMobile ? "secthree-cc--quote-mob" : ""
                  }`}
                >
                  {t.quote}
                </p>
              </div>
              <div className="secthree-cc--founder-info">
                <img
                  src={t.image}
                  alt={t.founder_name}
                  className="secthree-cc--founder-img"
                />
                <div className="secthree-cc--founder-text">
                  <p className="secthree-cc--founder-name">{t.founder_name},</p>
                  <p className="secthree-cc--company-name">{t.company_name}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      {/* ✅ Custom navigation controls */}
      <div className="carousel-controls-cc">
        <div
          style={{ color: "#fff", opacity: "0.8", cursor: "pointer" }}
          onClick={() => sliderRef.current.slickPrev()}
        >
          <FiArrowLeftCircle size={isMobile ? 30 : 50} />
        </div>
        <div
          style={{ color: "#fff", opacity: "0.8", cursor: "pointer" }}
          onClick={() => sliderRef.current.slickNext()}
        >
          <FiArrowRightCircle size={isMobile ? 30 : 50} />
        </div>
      </div>


      
    </div>
  );
};

export default SectionThree;
